import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import { Fragment } from "react";

Font.register({
  family: "Roboto",
  fonts: [
    { src: "http://fonts.gstatic.com/s/roboto/v15/W5F8_SL0XFawnjxHGsZjJA.ttf" },
    {
      src: "http://fonts.gstatic.com/s/roboto/v15/bdHGHleUa-ndQCOrdpfxfw.ttf",
      fontStyle: "normal",
      fontWeight: 700,
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    fontSize: 12,
    color: "#454546",
    paddingBottom: 100,
  },
  header: {
    paddingHorizontal: 40,
    paddingTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  logo: { width: "auto", height: 64 },
  headerright: { width: "auto", height: 45 },
  watermark: {
    position: "absolute",
    top: "35%",
    left: "15%",
    width: "70%",
    opacity: 0.04,
    zIndex: "-10",
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "Roboto",
    color: "#000",
    marginBottom: 20,
  },
  information: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "row",
    justifyContent: "space-between",
    paddingHorizontal: 40,
    marginBottom: 10,
  },
  textBold: { color: "#000", fontSize: 12, fontFamily: "Roboto" },
  text: { marginBottom: 5, fontSize: 12, fontFamily: "Roboto" },

  // Bloque por cita
  citaBlock: {
    marginHorizontal: 40,
    marginBottom: 12,
    borderRadius: 4,
    overflow: "hidden",
  },
  citaHeader: {
    backgroundColor: "#f0f0f0",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingHorizontal: 10,
    paddingVertical: 6,
  },
  citaFecha: { fontSize: 11, fontFamily: "Roboto", fontWeight: 700, color: "#183253" },
  citaTipo: {
    fontSize: 9,
    fontFamily: "Roboto",
    color: "#18bda6",
    borderWidth: 1,
    borderColor: "#18bda6",
    borderRadius: 10,
    paddingHorizontal: 6,
    paddingVertical: 2,
  },

  // Tabla de piezas
  table: { display: "table", width: "auto", marginHorizontal: 0 },
  tableHeader: {
    flexDirection: "row",
    backgroundColor: "#fafafa",
    borderBottomWidth: 1,
    borderBottomColor: "#e0e0e0",
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#eee",
    minHeight: 28,
    alignItems: "flex-start",
  },
  cellDiente: { width: "10%", padding: "4px 5px", fontSize: 9, fontFamily: "Roboto", textAlign: "center" },
  cellDiag:   { width: "25%", padding: "4px 5px", fontSize: 9, fontFamily: "Roboto" },
  cellTrat:   { width: "30%", padding: "4px 5px", fontSize: 9, fontFamily: "Roboto" },
  cellNotas:  { width: "35%", padding: "4px 5px", fontSize: 9, fontFamily: "Roboto" },
  cellHeader: { fontWeight: 700, color: "#000" },

  // Firma
  signatureSection: {
    marginTop: 40,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingHorizontal: 40,
  },
  signatureContainer: { width: "100%", textAlign: "center", alignItems: "center" },
  firma: { width: 120, height: 90, alignSelf: "center" },
  signatureLine: { marginBottom: 5, fontSize: 12, fontFamily: "Roboto" },
});

const HistorialTratamientosPdf = ({ nombre, historial, doctorData }) => {
  return (
    <Document>
      <Page size="LETTER" style={styles.page} wrap>
        <Image fixed style={styles.watermark} src="/images/watermark.jpg" />
        <View fixed style={styles.header}>
          <Image style={styles.logo} src="/images/logoderecho.jpg" />
          <Image style={styles.headerright} src="/images/headerright.png" />
        </View>

        <Text style={styles.title}>HISTORIAL DE TRATAMIENTOS</Text>

        <View style={styles.information}>
          <View>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Paciente: </Text>{nombre}
            </Text>
            <Text style={styles.text}>
              <Text style={styles.textBold}>Fecha de impresión: </Text>
              {new Date().toLocaleDateString("es-ES")}
            </Text>
          </View>
        </View>

        {historial.map((cita, cIdx) => (
          <View key={cIdx} style={styles.citaBlock} wrap={false}>
            {/* Cabecera de la cita */}
            <View style={styles.citaHeader}>
              <Text style={styles.citaFecha}>{cita.fecha}</Text>
            </View>

            {/* Tabla de piezas */}
            <View style={styles.table}>
              <View style={styles.tableHeader}>
                <Text style={[styles.cellDiente, styles.cellHeader]}>Pieza</Text>
                <Text style={[styles.cellDiag,   styles.cellHeader]}>Diagnóstico</Text>
                <Text style={[styles.cellTrat,   styles.cellHeader]}>Tratamiento</Text>
                <Text style={[styles.cellNotas,  styles.cellHeader]}>Notas</Text>
              </View>
              {cita.piezas.map((pieza, pIdx) => (
                <Fragment key={pIdx}>
                  <View style={[styles.tableRow, pIdx % 2 !== 0 && { backgroundColor: "#f9f9f9" }]}>
                    <Text style={styles.cellDiente}>{pieza.diente}</Text>
                    <Text style={styles.cellDiag}>{pieza.diagnostico || "—"}</Text>
                    <Text style={styles.cellTrat}>{pieza.tratamiento || "—"}</Text>
                    <Text style={styles.cellNotas}>
                      {pieza.notas?.length > 0
                        ? pieza.notas.map((n) => `${n.fecha}: ${n.nota}`).join("\n")
                        : "—"}
                    </Text>
                  </View>
                </Fragment>
              ))}
            </View>
          </View>
        ))}

        {/* Firma */}
        <View wrap={false} style={styles.signatureSection}>
          <View style={styles.signatureContainer}>
            <Image style={styles.firma} src="/images/firma.png" />
            <Text style={styles.signatureLine}>______________________</Text>
            <Text style={styles.text}>{doctorData?.printer_name}</Text>
            <Text style={styles.text}>{doctorData?.specialty}</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default HistorialTratamientosPdf;
